import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=a51df448&scoped=true"
import script from "./NotificationComponent.vue?vue&type=script&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./NotificationComponent.vue?vue&type=style&index=0&id=a51df448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51df448",
  null
  
)

export default component.exports